






































































































































































































import { Vue, Component } from "vue-property-decorator";

import "@/assets/css/home.css";
import Moment from "moment-timezone";
import AbpBase from "@/lib/abpbase";
import echarts from "echarts";
import vueSeamlessScroll from 'vue-seamless-scroll';

@Component({ components: { vueSeamlessScroll } })
export default class Home extends AbpBase {
  elemeter: any; //电表在线
  waterchart: any; //水表在线
  collectorchart: any; //通信设备在线
  weekusebar: any; //七天用量
  totalammountchart: any; //30天缴费
  timer: number;
  created() {
    this.$data.eledata.push({ value: 0, name: this.L("TotalMeter") });
  }
  mounted() {
    this.timer = setInterval(() => {
      this.getdata();
    }, 1000);
    this.elemeter = echarts.init(
      document.getElementById("elemeter") as HTMLDivElement
    );
    this.waterchart = echarts.init(
      document.getElementById("watermeter") as HTMLDivElement
    );
    this.collectorchart = echarts.init(
      document.getElementById("collectorstate") as HTMLDivElement
    );
    this.weekusebar = echarts.init(
      document.getElementById("weekuse") as HTMLDivElement
    );
    this.totalammountchart = echarts.init(
      document.getElementById("monthTotalAmmount") as HTMLDivElement
    );
    this.meterstate();
    this.collectorstate();
    this.getweekuse();
    this.getCollectionlist();
    this.gettotaluse();
    this.getwaringmessage();
    //自动缩放
    window.addEventListener("resize", () => {
      this.elemeter.resize();
      this.waterchart.resize();
      this.collectorchart.resize();
      this.weekusebar.resize();
      this.totalammountchart.resize();
    });
  }
  //定时器方法
  getdata() {
    this.$data.gettime = Moment().format("YYYY-MM-DD HH:mm:ss"); // 修改数据date
  }
  // 销毁定时器
  beforeDestroy() {
    if (this.$data.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  }
  //获取表计状态
  async meterstate() {
    await this.$store
      .dispatch("meterinfo/getMeterInfo")
      .then((val) => {
        if (val != undefined) {
          let elemeter = val.filter((ele) => {
            return ele.meterType == 23;
          });
          if (elemeter.length > 0) {
            this.$data.eletotal = elemeter[0].totalNum;
            this.elemeter.setOption(this.$data.pieoption(elemeter[0].data));
          } else {
            this.elemeter.setOption(this.$data.pieoption(this.$data.eledata));
          }
          let water = val.filter((ele) => {
            return ele.meterType == 22;
          });
          if (water.length > 0) {
            this.$data.watertotal = water[0].totalNum;
            this.waterchart.setOption(this.$data.pieoption(water[0].data));
          } else {
            this.waterchart.setOption(this.$data.pieoption(this.$data.eledata));
          }
        } else {
          this.elemeter.setOption(this.$data.pieoption(this.$data.eledata));
          this.waterchart.setOption(this.$data.pieoption(this.$data.eledata));
        }
      })
      .catch((err) => {
        this.elemeter.setOption(this.$data.pieoption(this.$data.eledata));
        this.waterchart.setOption(this.$data.pieoption(this.$data.eledata));
      });
  }
  //获取采集器状态
  async collectorstate() {
    await this.$store
      .dispatch("collectorinfo/getcollectoronlinestate")
      .then((val) => {
        if (val != undefined) {
          (this.$data.collectorTotal = val.totalNum),
            this.collectorchart.setOption(this.$data.pieoption(val.data));
        }
      })
      .catch((err) => {
        this.collectorchart.setOption(this.$data.pieoption(this.$data.eledata));
      });
  }
  //获取七天用量
  async getweekuse() {
    await this.$store
      .dispatch({
        type: "readrecord/getTotalUse",
        startTime: Moment()
          .day(-7)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: Moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      })
      .then((val) => {
        if (val != undefined) {
          this.weekusebar.setOption(this.$data.baroption(val));
        }
      });
  }
  //获取30天收款
  async getCollectionlist() {
    await this.$store
      .dispatch({
        type: "collectionlist/getTotalUse",
        startTime: Moment()
          .day(-30)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: Moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      })
      .then((val) => {
        if (val != undefined) {
          this.totalammountchart.setOption(this.$data.baroption(val));
        }
      });
  }
  //获取告警数据
  async getwaringmessage() {
    await this.$store.dispatch("waringmessage/getHomeMessage").then((val) => {
      if (val != undefined && val.length > 0) {
        this.$data.waringlist = val;
      }
    });
  }
  //获取用量数据
  async gettotaluse() {
    await this.$store.dispatch("readrecord/gethomeTotalUse").then((val) => {
      if (val != undefined) {
        this.$data.totaluse = val;
      }
    });
  }
  //告警信息更多
  morewaring() {
    this.$router.push({ name: "waringmessage", params: { waringId: "" } });
  }
  data() {
    return {
      gettime: Moment().format("YYYY-MM-DD HH:mm:ss"),
      eledata: [],
      eletotal: 0,
      watertotal: 0,
      collectorTotal: 0,
      waringlist: [],
      totaluse: [],
      waringId: "",
      //饼图参数
      pieoption(data) {
        return {
          tooltip: {
            trigger: "item",
          },
          legend: {
            textStyle: {
              fontSize: 11,
            },
            type: "scroll",
            orient: "vertical",
            right: 10,
            bottom: 20,
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["60%", "90%"],
              avoidLabelOverlap: false,
              center: ["30%", "50%"],
              color: ['#A7CB06', '#F9BE00', '#CB7DB0', '#30BCEF'],
              label: {
                show: false,
                position: "center",
              },
              labelLine: {
                show: false,
              },
              data: data,
            },
          ],
        };
      },
      //柱形图参数
      baroption(bardto) {
        let colorlist = ['#A7CB06', '#30BCEF', '#CB7DB0', '#027086', '#F9BE00'];
        let seriesList = [];
        let c = 0;
        bardto.series.forEach((ele) => {
          seriesList.push({
            name: ele.name,
            type: ele.type,
            data: ele.data,
            itemStyle: {
              color: colorlist[c++],
            },
            // label: {
            //   normal: {
            //     show: true,
            //     position: 'top'
            //   }
            // },
          })
        });
        //bardto.series.push('color':['#A7CB06','#30BCEF','#CB7DB0','#027086','#F9BE00']);
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: seriesList,
        };
      },
    };
  }
}
